export function getExtensionFromFile(filename) {
  var regex = /(?:\.([^.]+))?$/;
  return regex.exec(filename)[1];
}
